module.exports = __webpack_public_path__ + "static/media/meitheal-architects.e3144ad0.png";